import { StateUtils } from '@spartacus/core';
import { REMOVE_COMPANY_ENTITY } from '../company-state';

export const REMOVE_COMPANY = '[Company] Remove Company';
export const REMOVE_COMPANY_SUCCESS = '[Company] Remove Company Success';
export const REMOVE_COMPANY_FAIL = '[Company] Remove Company Fail';
export const RESET_REMOVED_COMPANY = '[Company] Reset Removed Company';

export class RemoveCompany extends StateUtils.LoaderLoadAction {
  readonly type = REMOVE_COMPANY;

  constructor(public payload: string) {
    super(REMOVE_COMPANY_ENTITY);
  }
}

export class RemoveCompanySuccess extends StateUtils.LoaderSuccessAction {
  readonly type = REMOVE_COMPANY_SUCCESS;

  constructor(public payload: string) {
    super(REMOVE_COMPANY_ENTITY);
  }
}

export class RemoveCompanyFail extends StateUtils.LoaderFailAction {
  readonly type = REMOVE_COMPANY_FAIL;

  constructor() {
    super(REMOVE_COMPANY_ENTITY);
  }
}

export class ResetRemovedCompany extends StateUtils.LoaderResetAction {
  readonly type = RESET_REMOVED_COMPANY;

  constructor() {
    super(REMOVE_COMPANY_ENTITY);
  }
}

export type RemoveCompanyActions = RemoveCompany | RemoveCompanySuccess | RemoveCompanyFail | ResetRemovedCompany;
